import React from 'react';
import { Button, Form } from 'antd';

import { useReportKm } from 'components/organism/reports/hooks';
import { getAmountDisplay } from 'utils/amount';
import { DescriptionItem } from 'components/atom/form';
import { FileTextOutlined } from '@ant-design/icons';
import { API_DATE_FORMAT, DATE_FORMAT } from 'utils/date';
import { NewCrudHeader } from 'components/organism/crud/new-header';
import { OrganizationUserDropdown } from 'components/organism/organizationUsers/dropdown';
import { ContactsDropdown } from 'components/organism/contact';
import { DateRangeInput } from 'components/organism/reports/date-range';
import { ReportSummary } from 'components/organism/reports/report-summary';
import { ReportBreakDown } from 'components/organism/reports/report-breakdown';
import { IExpense } from 'models';

export default function ReportKm() {
  const { loading, generate, obj } = useReportKm();

  const [form] = Form.useForm();
  const initialValues = {
    idAssignee: '-1',
    idContact: '-1',
  };

  const handleGenerate = async () => {
    try {
      const values = await form.validateFields();
      values.startDate = values.startDate.format(API_DATE_FORMAT);
      values.endDate = values.endDate.format(API_DATE_FORMAT);
      await generate(values);
    } catch (e) {}
  };

  return (
    <>
      <NewCrudHeader title="Kilometres Report" icon={<FileTextOutlined />} actions={[]} />
      <Form form={form} layout="vertical" initialValues={initialValues}>
        <DateRangeInput disabled={loading} />
        <OrganizationUserDropdown name="idAssignee" label="Assignee" required disabled={loading} />
        <ContactsDropdown name="idContact" required disabled={loading} />
        <Button className="no-print" type="primary" onClick={handleGenerate} style={{ width: '100%' }} disabled={loading} loading={loading}>
          Generate
        </Button>
      </Form>
      {!loading && obj?.summary && (
        <ReportSummary>
          <ReportSummary.Item left={<>Number of expenses</>} right={obj?.summary.count} />
          <ReportSummary.Item left={<>Kilometres</>} right={obj?.summary.kms} />
          <ReportSummary.Item left={<>Total</>} right={getAmountDisplay(obj?.summary.totalInclGst)} />
        </ReportSummary>
      )}

      {!loading && obj?.data.length! > 0 && <ShiftReportItemBreakdown data={obj?.data!} />}
    </>
  );
}

interface KmeportItemBreakdownProps {
  data: Array<IExpense>;
}
function ShiftReportItemBreakdown(props: KmeportItemBreakdownProps) {
  return (
    <ReportBreakDown
      title="Breakdown"
      data={props.data}
      renderLeft={(item) => {
        return (
          <>
            <span style={{ marginLeft: '5px' }}>{item.date.format(DATE_FORMAT)}</span>
          </>
        );
      }}
      renderRight={(item) => getAmountDisplay(item.amountInclGst)}
      renderItem={(item) => {
        return (
          <>
            <DescriptionItem title="Contact" content={item.contact?.fullName} />
            <DescriptionItem title="Assignee" content={item.shift?.assignee?.fullName} />
            <DescriptionItem title="Kilometres" content={item.kms} />
            <DescriptionItem title="Amount GST" content={getAmountDisplay(item.amountGst)} />
          </>
        );
      }}
    />
  );
}
